module.exports = __webpack_public_path__ + "img/Community.4fa80479.svg";